const nextgenvapes = {
    id: 'nextgenvapes',
    publicSiteName: 'Nextgen Vapes',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#bb0025',
            secondary: '#000000',
            color1: '#df0d37',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/nextgenvapes/favicon.ico',
        logo: '/nextgenvapes/logo.png',
    },
    features: {
        rewards: false,
        subscriptions: false,
    },
}

export default nextgenvapes